import { render, staticRenderFns } from "./ContractFormSidebar.vue?vue&type=template&id=13bb1e17&scoped=true"
import script from "./ContractFormSidebar.vue?vue&type=script&lang=js"
export * from "./ContractFormSidebar.vue?vue&type=script&lang=js"
import style0 from "./ContractFormSidebar.vue?vue&type=style&index=0&id=13bb1e17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bb1e17",
  null
  
)

export default component.exports